import ShareAccountInfo from "./ShareAccountInfo";

export default ShareAccountInfo;